import styled from 'styled-components';

export const Divider = styled.div`
    width: 100%;
    height: 0;
    border-bottom: 1px solid ${props => props.theme.root.colors.basicColors['8%']};
`;
